var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2569_165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2367 1.70502H9.45022V1.34316C9.45022 0.968766 9.14072 0.666748 8.76025 0.666748H3.2391C2.85862 0.666748 2.54913 0.968766 2.54913 1.34316V1.70502H1.76263C0.973285 1.70502 0.333008 2.32019 0.333008 3.07454V13.9639C0.333008 14.7182 0.973285 15.3334 1.76263 15.3334H10.2381C11.0261 15.3334 11.6663 14.7182 11.6663 13.9639V3.07454C11.6663 2.32019 11.0261 1.70502 10.2381 1.70502H10.2367ZM3.92765 2.01957H8.06886V2.7433H3.92907V2.01957H3.92765ZM10.2367 13.9806L1.71294 13.9639L1.76121 3.05784H2.54771V3.41971C2.54771 3.7941 2.8572 4.09611 3.23768 4.09611H8.76025C9.14072 4.09611 9.45022 3.7941 9.45022 3.41971V3.0648L10.285 3.07315L10.2367 13.9792V13.9806Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.92536 7.37109H4.07376C3.69328 7.37109 3.38379 7.67311 3.38379 8.0475C3.38379 8.42189 3.69328 8.72391 4.07376 8.72391H7.92536C8.30583 8.72391 8.61532 8.42189 8.61532 8.0475C8.61532 7.67311 8.30583 7.37109 7.92536 7.37109Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.92536 9.82617H4.07376C3.69328 9.82617 3.38379 10.1282 3.38379 10.5026C3.38379 10.877 3.69328 11.179 4.07376 11.179H7.92536C8.30583 11.179 8.61532 10.877 8.61532 10.5026C8.61532 10.1282 8.30583 9.82617 7.92536 9.82617Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2569_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3333,
    height: 14.6667,
    fill: "current",
    transform: "translate(0.333008 0.666748)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.ae275b8f.svg";
export { ForwardRef as ReactComponent };